import { Button } from '@finn/design-system/atoms/button';
import { HookFormCheckbox } from '@finn/platform-modules';
import { parseToHtml } from '@finn/ui-utils';
import { useState } from 'react';

export const GDPRField = ({
  form,
  name,
  label,
  moreInfoTitle,
  lessInfoTitle,
  gdprDetails,
}) => {
  const [showGdpr, setShowGdpr] = useState(false);

  const handleGDPRToggle = (e) => {
    e.preventDefault();
    setShowGdpr(!showGdpr);
  };

  return (
    <>
      <HookFormCheckbox form={form} name={name}>
        {label}
      </HookFormCheckbox>
      <div className="[&_p]:body-14-regular ml-6 [&_p]:pt-1">
        <Button variant="action" size="md" onClick={handleGDPRToggle}>
          {showGdpr ? lessInfoTitle : moreInfoTitle}
        </Button>
        {showGdpr && (
          <>
            <br />
            <br />
            <div className="body-14-regular">{parseToHtml(gdprDetails)}</div>
          </>
        )}
      </div>
    </>
  );
};
